import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GlobalVar } from '../globals/global-var';
import { MatTableParameter } from '../models/mat-table-parameter';

@Injectable({
  providedIn: 'root'
})
export class TokenService {

  constructor(private http: HttpClient, private globalVar: GlobalVar) {
   
  }

  postLoginApi(loginView): Observable<any> {
    this.globalVar.memberMTP = new MatTableParameter();
    return this.http.post<any>(this.globalVar.targetIp + '/api/Token/Login', loginView);
  }

  getMemberApi(): Observable<any> {
    return this.http.get<any>(this.globalVar.targetIp + '/api/Token/mine');
  }

  logout() {
    sessionStorage.removeItem('authSystem_token');
    sessionStorage.removeItem('authSystem_mine');
    this.globalVar.loggedIn = false;
    this.globalVar.mine = null;
    this.globalVar.companyName = "";
  }

}
